import { render, staticRenderFns } from "./TheReviews.vue?vue&type=template&id=6ae521b3&scoped=true"
import script from "./TheReviews.vue?vue&type=script&lang=js"
export * from "./TheReviews.vue?vue&type=script&lang=js"
import style0 from "./TheReviews.vue?vue&type=style&index=0&id=6ae521b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae521b3",
  null
  
)

export default component.exports